import { InjectionToken } from '@angular/core';
import type { SchedulerLike } from 'rxjs';

export const LOCAL_STORAGE_TEST_SCHEDULER = new InjectionToken<SchedulerLike>(
  'LocalStorageTestScheduler',
);
